var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),(_vm.isLoading)?_c('div',{staticClass:"infinite-scroll__loading-container"},[_c('JoeyLoading')],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }